import { Injectable } from '@angular/core';
import { TaskPropertiesObject } from 'src/app/models/tasks/tasks-properties/task-properties/task-properties-object.model';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Injectable({
    providedIn: 'root'
})
export class TaskPropertiesConverter implements Converter<TaskPropertiesObject> {
    convert(input: any): TaskPropertiesObject {
        try {
            if (isNullOrUndefined(input)) return TaskPropertiesObject.create();

            return new TaskPropertiesObject(input.assignedTo, StringUtils.default(input.id),
                StringUtils.default(input.type), StringUtils.default(input.name),
                StringUtils.default(input.order.process.id), StringUtils.default(input.taskProcessFlowChart),
                StringUtils.default(input.order.service.id), StringUtils.default(input.order.id), StringUtils.default(input.order.type));
        } catch (error) {
            console.error(error);
            return TaskPropertiesObject.create();
        }
    }

}
